import styled from '@emotion/styled'
import { textChangeRangeIsUnchanged } from 'typescript'

export const ParentRowDiv = styled.div`
  label: ParentRowDiv;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  font-weight: 900;
  color: #000;
`

export const EmptyTextDiv = styled.div`
  label: EmptyTextDiv;
  width: 70%;
`

export const TitlesDiv = styled.div`
  label: TitlesDiv;
  display: flex;
  justify-content: space-between;
`

export const TitleDiv = styled.div`
  label: TitleDiv;
  text-align: right;
  width: 100px;
`
export const TaxMedicareSavingDiv = styled.div`
  label: TaxMedicareSavingDiv;
  text-align: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'center' : 'left'};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '14px' : '12px')};
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  margin: 6px;
`

export const ColouredBlock = styled.div`
    label: ColouredBlock;
    text-align: center;
    margin: 0 auto;
    color: #fff !important;
    padding: 12px 16px;
    border-radius: 6px;
    max-width: 213px;
    font-size: ${(props) => props.theme.font.caption.fontSize};
    background: ${(props) => props.theme.brand === 'Maxxia' ? '#003D79' : '#3CB387'};
`